import { lazy } from 'react'

import { urlRoutes } from 'presentation/routes/config/urlRoutes/urlRoutes'

export const SelectedDestinationsRoutes = [
  {
    nameUrl: 'Destinos seleccionados',
    path: urlRoutes.private.selectedDestinations.url,
    element: lazy(() => import('presentation/pages/selectedDestinations')),
    rols: ['*'],
  },
]
